<template>
    <div>
        <div v-for="{desc, title} in healthCareProviders" class="rounded shadow m-3">
            <h6 class="mb-0 bg-light-skyler p-3 rounded">
                {{title}}
            </h6>

            <p class="mb-0 p-3">
                {{desc}}
            </p>
        </div>

        <infinite-loading @infinite="load">
            <span slot="no-more"></span>
            <span slot="no-results" class="position-absolute absolute-center">{{t('No results')}}</span>
        </infinite-loading>
    </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading'

    export default {
        name: "HealthCareProviders",
        inject: ['dataRepo'],
        components: {
            InfiniteLoading
        },
        data: () => ({
            healthCareProviders: [],
            page: 0
        }),
        methods: {
            load(state) {
                this.dataRepo.healthCareProviders(this.page)
                    .catch(err => this.$handleError(err))
                    .then(data => {
                        if (data) {
                            this.healthCareProviders.push(...data.data)
                            state.loaded();
                            this.page++;
                        }

                        if (!data || data.data.length < 10) {
                            state.complete();
                        }
                    })
            },
        },
        mounted() {
            if (this.$route.query.pay_alert) {
                this.$swal.fire({
                    text: "Please pay within 3 days at one of the providers listed",
                    icon: 'warning'
                })
            }
        }
    }
</script>

<style scoped>

</style>
